import { SvgIcon, SvgIconProps } from '@mui/material';

export const Pencil = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path
      fillRule="evenodd"
      d="M18.53 1.47l-.53-.53-.53.53-2.993 2.993-.015.015-9.993 9.993-.161.161-.045.223-1 5-.221 1.103 1.103-.221 5-1 .223-.045.161-.16 10-10 3-3 .53-.53-.53-.53-4-4zm.47 6.47L20.938 6l-2.939-2.939L16.06 5l1.47 1.47 1.47 1.47zm-4-1.879l1.47 1.47L17.938 9l-9.309 9.309-3.674.735.735-3.674 9.309-9.309z"
      fill="currentColor"
    />
  </SvgIcon>
);
